import type { JobType } from '@/enum'
import type { IActivity } from '@/interfaces/IActivity'
import { Job } from './jobs'
import type { IJob } from '@/interfaces'
import AppUser from './AppUser'
import type { IAppUser } from '@/interfaces/app-user/IAppUser'

class Activity implements IActivity {
  title: string
  description: string
  jobId: string
  job: IJob
  timestamp: string
  userId: string
  user: IAppUser
  jobType?: JobType
  createdAt: string

  constructor(activity: any) {
    this.title = activity?.title
    this.description = activity?.description
    this.jobId = activity?.jobId
    this.job = new Job(activity?.job)
    this.timestamp = activity?.timestamp
    this.userId = activity?.userId
    this.user = new AppUser(activity?.user)
    this.createdAt = activity?.createdAt
    this.jobType = this.job.type
  }
}

export default Activity
